import BenefitsIntegration from "@components/BenefitsIntegration";
import CarouselItem from "@components/CarousalItem";
import IntegrationCard from "@components/IntegrationCard";
import IntegrationSnapshot from "@components/Integration-snapshot";
import IntegrationHeader from "@components/LandingPageComponents/integrationHeader";
import YellowCardOneButton from "@components/LandingPageComponents/RazorPayComponents/YellowCardOneButton";
import NewLayout from "@components/new-ui/Layout";
import React from "react";
import YellowCTAhref from "@components/yellowCTAhref";

const items = [
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/odoo-pillar-icon.png",
        title: "Odoo",
        subtext: "CRM",
        imageUrl: "https://assets.gallabox.com/gb-home/integration-pillar/section-odoo.png",
        description: "Send automated notifications and alerts to your Odoo contacts through WhatsApp",
        link: "https://gallabox.com/whatsapp-integrations/odoo",
    },

    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-facebook.png",
        title: "Facebook Lead Ads",
        subtext: "Marketing",
        imageUrl: "https://assets.gallabox.com/gb-home/fb-leads/header.png",
        description: "Move New Facebook Leads to WhatsApp Instantly",
        link: "https://gallabox.com/whatsapp-integrations/facebook-leads-to-whatsapp",
    },

    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/moengage-pillar-icon.png",
        title: "MoEngage",
        subtext: "Marketing",
        imageUrl: "https://assets.gallabox.com/gb-home/integration-pillar/section-moengage.png",
        description: "Make your customer engagement activities cost-effective with our MoEngage connector",
        link: "https://gallabox.com/whatsapp-integrations/moengage",
    },
];

const data = [
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-zoho.png",
        title: "Zoho",
        subtext: "CRM",
        description: "Get a single source of truth with a two-way sync between Gallabox and Zoho CRM",
        link: "https://gallabox.com/whatsapp-integrations/zoho",
        new: true,
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-hubspot.png",
        title: "HubSpot",
        subtext: "CRM",
        description: "Unify communication by integrating HubSpot with your WhatsApp Business account",
        link: "https://gallabox.com/whatsapp-integrations/hubspot",
        new: true,
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-shopify.png",
        title: "Shopify",
        subtext: "Commerce",
        description: "Connect Shopify to WhatsApp to share order updates, abandoned cart alerts, and more",
        link: "https://gallabox.com/whatsapp-integrations/shopify",
        new: true,
    },
    {
        logo: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-sheets.png",
        title: "Google Sheets",
        subtext: "Data Storage",
        description: "Eliminate manual intervention and errors by seamlessly integrating with Google Sheets",
        link: "https://gallabox.com/whatsapp-integrations/google-sheets",
        new: true,
    },
];
const whatsappIntegrations: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp Integrations to Automate Business | Gallabox"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/integration-pillar/pillar-og.png" }}
            canonical="https://gallabox.com/whatsapp-integrations"
            description="Gallabox’s WhatsApp integration enables smooth data transfer across your business tools, automating chats, managing leads, and streamlining workflows."
        >
            <IntegrationHeader
                title="Powerful WhatsApp Integrations to Automate Chats & Drive Business Growth"
                description="Track engagement rates, campaign performance, and payment collection in real time through seamless API integration."
                imageUrl="https://assets.gallabox.com/gb-home/integration-pillar/pillar-header-new.png"
            />

            <CarouselItem items={items} />

            <section className="py-10 px-2  mx-auto lg:pb-20 pb-10" style={{ maxWidth: "1200px" }}>
                <div className="mx-auto text-center rounded">
                    <h2 className="text-2xl md:text-3xl font-bold mb-10 inline-block text-gray-700">{"Latest WhatsApp Business Integrations"}</h2>
                    <IntegrationCard items={data} />
                </div>
            </section>

            <IntegrationSnapshot />

            <YellowCardOneButton
                bgColor="bg-blue-50"
                customText={<h4 className="text-gray-700 lg:text-2xl text-base">Can&apos;t find a direct connection for your favourite app? We’ll happily create one for you!</h4>}
                buttonText="Submit Request"
                txtcolor="gray-700"
                linkUrl="https://feedback.gallabox.com/integrations"
            />
            <BenefitsIntegration />
            <YellowCTAhref customText="Experience the Full Power of WhatsApp Automation with Gallabox Connections" buttonText="Get Started for FREE" />
        </NewLayout>
    );
};

export default whatsappIntegrations;
